import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { leggiConsenso, salvaConsenso, sceltaCompleta } from "@/lib/consenso";

const Riga = ({ titolo, testo, children }) => (
  <div className="flex items-center justify-between gap-3"><span><b>{titolo}</b><br /><span className="text-slate-500">{testo}</span></span>{children}</div>
);

export const ConsensoBanner = () => {
  const [visibile, setVisibile] = useState(() => !sceltaCompleta(leggiConsenso()));
  const [personalizza, setPersonalizza] = useState(false);
  const [terze, setTerze] = useState(() => leggiConsenso()?.terze_parti ?? false);
  const [stat, setStat] = useState(() => leggiConsenso()?.statistiche ?? false);

  useEffect(() => {
    const apri = () => {
      const c = leggiConsenso();
      setTerze(c?.terze_parti ?? false); setStat(c?.statistiche ?? false);
      setPersonalizza(true); setVisibile(true);
    };
    window.addEventListener("consenso-apri", apri);
    return () => window.removeEventListener("consenso-apri", apri);
  }, []);

  const scegli = (t, s) => { salvaConsenso({ terze_parti: t, statistiche: s }); setVisibile(false); setPersonalizza(false); };
  if (!visibile) return null;

  return (
    <div className="fixed z-[60] inset-x-2 bottom-20 md:bottom-4 md:inset-x-auto md:left-4 md:max-w-xl max-h-[75dvh] overflow-y-auto rounded-2xl bg-white border border-slate-200 shadow-2xl p-4 sm:p-5" role="dialog" aria-label="Consenso al trattamento dei dati personali" data-testid="consenso-banner">
      <div className="flex gap-3">
        <ShieldCheck className="w-6 h-6 text-sky-600 shrink-0" />
        <div className="text-xs sm:text-sm text-slate-600 space-y-2">
          <p className="font-bold text-slate-900 text-base">La tua privacy</p>
          <p>Usiamo strumenti tecnici necessari al funzionamento del sito. Solo con il tuo consenso attiviamo anche l'assistente virtuale (servizio di intelligenza artificiale di terze parti) e i cookie di statistica e marketing tramite Google Tag Manager.</p>
          <Link to="/privacy" className="font-semibold text-sky-700 underline" data-testid="consenso-privacy-link">Leggi l'informativa privacy</Link>
        </div>
      </div>
      {personalizza && (
        <div className="mt-4 space-y-3 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm" data-testid="consenso-preferenze">
          <Riga titolo="Necessari" testo="Funzionamento del sito, modulo richieste, area gestione"><Switch checked disabled data-testid="consenso-switch-necessari" /></Riga>
          <Riga titolo="Assistente virtuale (AI)" testo="I messaggi della chat vengono elaborati da un fornitore AI esterno"><Switch checked={terze} onCheckedChange={setTerze} data-testid="consenso-switch-assistente" /></Riga>
          <Riga titolo="Statistiche e marketing" testo="Google Tag Manager e i servizi Google collegati per misurare visite e campagne"><Switch checked={stat} onCheckedChange={setStat} data-testid="consenso-switch-statistiche" /></Riga>
        </div>
      )}
      <div className="mt-4 grid grid-cols-2 sm:flex gap-2">
        <button onClick={() => scegli(true, true)} className="h-11 px-5 rounded-full bg-sky-600 text-white text-sm font-bold hover:bg-sky-700 transition-colors" data-testid="consenso-accetta-btn">Accetta tutto</button>
        <button onClick={() => scegli(false, false)} className="h-11 px-5 rounded-full border border-slate-300 text-sm font-bold hover:bg-slate-50 transition-colors" data-testid="consenso-rifiuta-btn">Solo necessari</button>
        {personalizza ? (
          <button onClick={() => scegli(terze, stat)} className="col-span-2 h-11 px-5 rounded-full border border-sky-300 text-sky-800 text-sm font-bold hover:bg-sky-50 transition-colors" data-testid="consenso-salva-btn">Salva preferenze</button>
        ) : (
          <button onClick={() => setPersonalizza(true)} className="col-span-2 h-10 px-5 rounded-full text-sm font-semibold text-slate-600 hover:bg-slate-100 transition-colors" data-testid="consenso-personalizza-btn">Personalizza</button>
        )}
      </div>
    </div>
  );
};
